export const B2B_NOTIFICATION_UNREAD_REFRESH_EVENT = "b2b-notification-unread-refresh";

export function dispatchNotificationUnreadRefresh(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(B2B_NOTIFICATION_UNREAD_REFRESH_EVENT));
}
